module.exports = __webpack_public_path__ + "static/media/Nathalie Cortez Front End.5729a737.pdf";